import React from 'react';
import { Switch } from './ui/switch';

/**
 * Responsive On/Off Toggle
 * Mobile: Button style [Off] [On]
 * Desktop: Switch toggle style
 * Uses brand blue #007AFF for consistency
 */
const OnOffToggle = ({ value, onChange, className = '' }) => {
  return (
    <>
      {/* Mobile: Button Style */}
      <div className={`sm:hidden flex gap-1 bg-white rounded-md p-1 border border-gray-200 ${className}`}>
        <button
          type="button"
          onClick={() => onChange(false)}
          className={`px-3 py-1.5 text-xs font-medium rounded-md transition-colors ${
            !value 
              ? 'bg-gray-200 text-gray-900' 
              : 'text-gray-600 hover:text-gray-900'
          }`}
        >
          Off
        </button>
        <button
          type="button"
          onClick={() => onChange(true)}
          className={`px-3 py-1.5 text-xs font-medium rounded-md transition-colors ${
            value 
              ? 'text-white' 
              : 'text-gray-600 hover:text-gray-900'
          }`}
          style={value ? { background: '#007AFF' } : {}}
        >
          On
        </button>
      </div>
      
      {/* Desktop: Switch Style */}
      <div className={`hidden sm:block ${className}`}>
        <Switch 
          checked={value} 
          onCheckedChange={onChange}
        />
      </div>
    </>
  );
};

export default OnOffToggle;
